import * as React from 'react';

import { SuggestReminderPublishersReminderPublisherCollection200ResponseSuggestionsInner } from '@europrocurement/l2d-domain/openApi/ApiAchats';
import SuggestionSelector from '../Selectors/SuggestionSelector';

type SupplierSuggestion =
    SuggestReminderPublishersReminderPublisherCollection200ResponseSuggestionsInner;

interface SuggestionSelectionStepProps {
    suggestions: SupplierSuggestion[];
    isMultiSocietyMode: boolean;
    isProcessing: boolean;
    onSuggestionChange: (suggestions: SupplierSuggestion[]) => void;
    onBack: () => void;
    onNext: () => void;
}

export const SuggestionSelectionStep: React.FunctionComponent<SuggestionSelectionStepProps> =
    function ({
        suggestions,
        isMultiSocietyMode,
        isProcessing,
        onSuggestionChange,
        onBack,
        onNext,
    }) {
        // Référence pour stocker les suggestions sélectionnées
        const selectedSuggestionsRef = React.useRef<SupplierSuggestion[]>([]);

        // Initialisation par défaut avec la première suggestion
        React.useEffect(() => {
            if (suggestions && suggestions.length > 0) {
                selectedSuggestionsRef.current = [suggestions[0]];
                onSuggestionChange(selectedSuggestionsRef.current);
            }
        }, [suggestions, onSuggestionChange]);

        const handleSuggestionChange = React.useCallback(
            (suggestion: SupplierSuggestion, checked: boolean) => {
                if (checked) {
                    // Ajouter le fournisseur s'il n'est pas déjà sélectionné
                    const alreadySelected = selectedSuggestionsRef.current.some(
                        (s) =>
                            s.fournisseur.id === suggestion.fournisseur.id &&
                            s.idSociete === suggestion.idSociete,
                    );
                    if (!alreadySelected) {
                        selectedSuggestionsRef.current = [
                            ...selectedSuggestionsRef.current,
                            suggestion,
                        ];
                    }
                } else {
                    // Retirer le fournisseur
                    selectedSuggestionsRef.current = selectedSuggestionsRef.current.filter(
                        (s) =>
                            !(
                                s.fournisseur.id === suggestion.fournisseur.id &&
                                s.idSociete === suggestion.idSociete
                            ),
                    );
                }

                // Mettre à jour la sélection dans le parent
                onSuggestionChange(selectedSuggestionsRef.current);
            },
            [onSuggestionChange],
        );

        return (
            <SuggestionSelector
                suggestions={suggestions}
                isMultiSocietyMode={isMultiSocietyMode}
                isProcessing={isProcessing}
                onSelectionChange={handleSuggestionChange}
                onBack={onBack}
                onContinue={onNext}
            />
        );
    };
